var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./ImageBarcodeReader.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-467974aa\"}!../../../vue-loader/lib/selector?type=template&index=0!./ImageBarcodeReader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-barcode-reader/src/components/ImageBarcodeReader.vue
// module id = 697
// module chunks = 1